import { TopicExplorerType } from '../enums/topicExplorer.enum';

export const TOPIC_EXPLORER_PAGE_DESCRIPTION =
  'Explore the topic of your choice! Topic Explorer provides detailed information and insights on the topics needed for your class discussion.';

export const TOPIC_EXPLORER_PAGE_EXPLORE =
  'What topic would you like to explore?';

export const TOPIC_EXPLORER_EXPLORER_DESCRIPTION =
  'Get detailed information and insights on your chosen topic for class discussion.';

export const TOPIC_EXPLORER_BREAKDOWN_DESCRIPTION =
  'Break down a specific topic to understand its core components and connections.';

export const TOPIC_EXPLORER_TYPES = [
  TopicExplorerType.EXPLORER,
  TopicExplorerType.BREAKDOWN,
];

export const TOPIC_EXPLORER_DEFAULT_TYPE = TopicExplorerType.EXPLORER;

export const TOPIC_EXPLORER_TITLE = 'Topic Explorer';
export const TOPIC_EXPLORER_TUTORIAL_DESKTOP_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialTopicExplorerDesktop.webp`;
export const TOPIC_EXPLORER_TUTORIAL_MOBILE_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialTopicExplorerMobile.webp`;

export const TOPIC_EXPLORER_BREAKDOWN_TUTORIAL_DESKTOP_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialTopicExplorerBreakdownDesktop.webp`;
export const TOPIC_EXPLORER_BREAKDOWN_TUTORIAL_MOBILE_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialTopicExplorerBreakdownMobile.webp`;
